function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tool"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.501 2.944c-.28-.162-.621-.179-.916-.044-.294.134-.506.402-.567.72l-.811 4.209c-.013.068-.137.171-.207.171h-2c-.07 0-.194-.103-.207-.171l-.811-4.209c-.061-.318-.273-.586-.567-.72s-.636-.117-.916.044c-2.158 1.25-3.499 3.571-3.499 6.056 0 2.288 1.136 4.436 3 5.738v6.262c0 .552.448 1 1 1h6c.552 0 1-.448 1-1v-6.262c1.864-1.302 3-3.45 3-5.738 0-2.485-1.341-4.806-3.499-6.056zm-1.002 10.381c-.309.179-.499.508-.499.865v5.81h-4v-5.81c0-.357-.19-.687-.499-.865-1.543-.893-2.501-2.551-2.501-4.325 0-1.267.488-2.474 1.33-3.386l.5 2.593c.192 1.005 1.146 1.793 2.17 1.793h2c1.024 0 1.978-.788 2.171-1.792l.5-2.593c.841.911 1.329 2.118 1.329 3.385 0 1.774-.958 3.432-2.501 4.325z"
}));

var Svg121Tool = function Svg121Tool(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg121Tool, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/121-tool.4bf571b6.svg";
export { ForwardRef as ReactComponent };